import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import RangeSliderBorderRadius from "../../../UI/RangeSliderBorderRadius";
import {
  AlignHorizontalJustifyStart,
  AlignHorizontalJustifyEnd,
  AlignVerticalJustifyStart,
  AlignVerticalJustifyEnd,
  AlignHorizontalSpaceBetween,
  AlignHorizontalSpaceAround,
 
  AlignHorizontalJustifyCenter,
  AlignHorizontalDistributeCenter,
  AlignVerticalJustifyCenter,
  AlignVerticalDistributeCenter,
  AlignVerticalSpaceBetween,
  Square,
  Squircle,
  Circle,
} from "lucide-react";
import {
  AlignVerticalSpaceAround,
  AlignVerticalJustifyStretch,
} from "lucide-react";
const ItemBorderRadiusUI =  ({ itemsArray, callbackItemValue, objectValue,objectName,displayName ,}) => {
  const [items ,setItems] =useState(itemsArray);
const [resolution, setPxPercent] = useState('%');
const [cornerType, setCornerType] = useState('');
 const flexDirectionIcons = {
  "row": <AlignHorizontalJustifyStart size={20} color="#666" />,
  "row-reverse": <AlignHorizontalJustifyEnd size={20} color="#666" />,
  "column": <AlignVerticalJustifyStart size={20} color="#666" />,
  "column-reverse": <AlignVerticalJustifyEnd size={20} color="#666" />
};
const justifyContentIcons = {
  "flex-start": <AlignHorizontalJustifyStart size={20} color="#666" />,
  "flex-end": <AlignHorizontalJustifyEnd size={20} color="#666" />,
  "center": <AlignHorizontalJustifyCenter size={20} color="#666" />,
  "space-between": <AlignHorizontalSpaceBetween size={20} color="#666" />,
  "space-around": <AlignHorizontalSpaceAround size={20} color="#666" />,
  "space-evenly": <AlignHorizontalDistributeCenter size={20} color="#666" />
};
const alignItemsIcons = {
  "flex-start": <AlignVerticalJustifyStart size={20} color="#666" />,
  "flex-end": <AlignVerticalJustifyEnd size={20} color="#666" />,
  "center": <AlignVerticalJustifyCenter size={20} color="#666" />,
  "stretch": <AlignVerticalSpaceBetween size={20} color="#666" />,  // use AlignVerticalJustifyStretch if available
  "baseline": <AlignVerticalDistributeCenter size={20} color="#666" /> // fallback to a generic if this isn't available
};
const alignContentIcons = {
  "flex-start": <AlignVerticalJustifyStart size={20} color="#666" />,
  "flex-end": <AlignVerticalJustifyEnd size={20} color="#666" />,
  "center": <AlignVerticalJustifyCenter size={20} color="#666" />,
  "stretch": <AlignVerticalSpaceBetween size={20} color="#666" />,
  "space-between": <AlignVerticalDistributeCenter size={20} color="#666" />,
  "space-around": <AlignVerticalSpaceAround size={20} color="#666" />
};
     const dispatch = useDispatch();  
     const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
            {
              
              dispatch({type: "CURSOR",payload:true  });
          
              dispatch({type: "CURSORTEXT",payload:CursorText})
              dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
              dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
            }
             
            const handleMouseLeave = () => {
              
              dispatch({type: "CURSOR",payload:false})
          
              dispatch({type: "CURSORTEXT",payload:""})
          
              dispatch({type: "CURSORTEXTBG",payload:""})
              dispatch({type: "CURSORTEXTCOLOR",payload:""})
            
          
          }
 const [itemValue, setItemValue] = useState(objectValue);
const [itemValueTL, setItemValueTL] = useState(objectValue?.topLeft);
const [itemValueTR, setItemValueTR] = useState(objectValue?.topRight);
const [itemValueBL, setItemValueBL] = useState(objectValue?.bottomLeft);
const [itemValueBR, setItemValueBR] = useState(objectValue?.bottomRight);
const [itemType, setItemType] = useState("topLeft");
 return(<>


<div style={{background:"#ffffff",borderRadius:"15px",marginTop:"10px",padding:"10px",}}>
       
               
             <div className="" style={{background:"rgba(144, 202, 249,0.2)",borderRadius:"10px",marginTop:"10px",marginBottom:"10px",paddingTop:"5px",paddingBottom:"5px",paddingBottom:"5px"}}> 
        
                      
            <h4>{displayName} </h4>
                        <div style={{display:"flex",justifyContent:"space-around"}}>
                        <div style={{}}>
            {itemType=="topLeft"?<RangeSliderBorderRadius resolution={resolution}  setSliderVal={(val)=>{ 
              
              callbackItemValue({value:val,resolution:resolution},`${objectName}TopLeft`)}}  
               sliderVal={objectValue?.topLeft?.value} />:""}
               {
                itemType=="topRight"?
                 <RangeSliderBorderRadius resolution={resolution}  setSliderVal={(val)=>{ 
             
              callbackItemValue({value:val,resolution:resolution},`${objectName}TopRight`)}}  
               sliderVal={objectValue?.topRight?.value} />:""}{
                itemType=="bottomLeft"?
           <RangeSliderBorderRadius resolution={resolution}  setSliderVal={(val)=>{ 
             
              callbackItemValue({value:val,resolution:resolution},`${objectName}BottomLeft`)}}  
               sliderVal={objectValue?.bottomLeft?.value} />:""}
               {itemType=="bottomRight"?
           <RangeSliderBorderRadius resolution={resolution}  setSliderVal={(val)=>{ 
             
              callbackItemValue({value:val,resolution:resolution},`${objectName}BottomRight`)}}  
               sliderVal={objectValue?.bottomRight?.value} />:""}{
                itemType=="all"? <RangeSliderBorderRadius resolution={resolution}  setSliderVal={(val)=>{ 
              setItemValue({value:val,resolution:resolution});
              callbackItemValue({value:val,resolution:resolution},`${objectName}All`)}}  
               sliderVal={itemValue?.value} />:""}
              <div style={{height:"50px" ,width:"90px"}}> 
            </div></div>
                         <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px"}} >
                                          
                                          <div  style={{display:"flex",justifyContent:"space-around"}}>
                                                  <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                            TL
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={itemType=="topLeft"?"yes":""}
                   className="input-textbox"  value={"topLeft"}  name={objectName}  
                   onClick={e=>{setItemType("topLeft");
                  }}/>
                        <span class={"boxCardBorder-two"}></span> </label> <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                             TR
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={itemType=="topRight"?"yes":""}
                   className="input-textbox"  value={"topRight"}  name={objectName}  
                   onClick={e=>{setItemType("topRight");
                  }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                           BL
                                                                     
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={itemType=="bottomLeft"?"yes":""}
                   className="input-textbox"  value="bottomLeft"  name={objectName}  
                   onChange={e=>{setItemType("bottomLeft");}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                             BR                      
                                                                     
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={itemType=="bottomRight"?"yes":""}
                   className="input-textbox"  value="bottomRight"  name={objectName}  
                   onChange={e=>{setItemType("bottomRight");}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                        </div> <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px"}} >
                                          
                                          <div  style={{display:"flex",justifyContent:"space-around"}}>
                                                  
                         
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} >
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                          %
                                                                     
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={resolution=="%"?"yes":""}
                   className="input-textbox"  value="%"  name={objectName+"px"}  
                   onChange={e=>{setPxPercent("%")}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            px                        
                                                                     
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={resolution=="px"?"yes":""}
                   className="input-textbox"  value="px"  name={objectName+"px"}   
                   onChange={e=>{setPxPercent("px")}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                        </div>  </div> </div>
               </div> 
               <div style={{height:"120px"}}> 
            <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px"}} >
                                          
                                          <div  style={{display:"flex",justifyContent:"space-around"}}>
                                               <h4>{"Corner Type  "} </h4>  
                                               <div>
                                                 <div  style={{display:"flex",justifyContent:"space-around"}}> <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                <div style={{display:"flex",justifyContent:"space-between", borderTopLeftRadius:`0%`,
              borderTopRightRadius:`0%`,
              borderBottomLeftRadius:`0%`,
              borderBottomRightRadius:`0%`,width:"30px",height:"30px",background:"rgba(144, 202, 249,0.9)",
              }} > </div> 
                              <input type="radio" title="Set As Years"   checked={cornerType=="square"?"yes":""}
                   className="input-textbox"  value={"square"}  name={objectName+"CornerType1"}   
                   onClick={e=>{setCornerType("square");
                    setItemValue({value:0,resolution:"px"});
                      callbackItemValue({title:displayName,topLeft:{value:0,resolution:"%"},
                      topRight:{value:0,resolution:"%"},
                      bottomLeft:{value:0,resolution:"%"},
                      bottomRight:{value:0,resolution:"%"}},`${objectName}All`);     }}/>
                        <span class={"boxCardBorder-two"} ></span> </label>
                        <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between",
                                             borderTopLeftRadius:`10%`,
              borderTopRightRadius:`10%`,
              borderBottomLeftRadius:`10%`,
              borderBottomRightRadius:`10%`,width:"30px",height:"30px",background:"rgba(144, 202, 249,0.9)",
              }} > </div> 
                              <input type="radio" title="Color Theme"   checked={cornerType=="squircle"?"yes":""}
                   className="input-textbox"  value="squircle"  name={objectName+"CornerType1"}  
                   onChange={e=>{setCornerType("squircle");
                   setItemValue({value:20,resolution:"px"});
                    callbackItemValue({title:displayName,topLeft:{value:20,resolution:"%"},
                      topRight:{value:20,resolution:"%"},
                      bottomLeft:{value:20,resolution:"%"},
                      bottomRight:{value:20,resolution:"%"}},`${objectName}All`);   }}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                              <div style={{display:"flex",justifyContent:"space-between",
                                               borderTopLeftRadius:`50%`,
              borderTopRightRadius:`50%`,
              borderBottomLeftRadius:`50%`,
              borderBottomRightRadius:`50%`,width:"30px",height:"30px",background:"rgba(144, 202, 249,0.9)",
              }} > </div> 
                              <input type="radio" title="Color Theme"   checked={cornerType=="circle"?"yes":""}
                   className="input-textbox"  value="circle"  name={objectName+"CornerType1"} 
                   onChange={e=>{setCornerType("circle");
                    setItemValue({value:50,resolution:"%"});
                   callbackItemValue({title:displayName,topLeft:{value:50,resolution:"%"},
                      topRight:{value:50,resolution:"%"},
                      bottomLeft:{value:50,resolution:"%"},
                      bottomRight:{value:50,resolution:"%"}},`${objectName}All`);
                  }}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                              <div style={{display:"flex",justifyContent:"space-between",
                                               borderTopLeftRadius:`90%`,
              borderTopRightRadius:`10%`,
              borderBottomLeftRadius:`30%`,
              borderBottomRightRadius:`50%`,width:"30px",height:"30px",background:"rgba(144, 202, 249,0.9)",
              }} > </div> 
                              <input type="radio" title="Color Theme"   checked={cornerType=="CornerTypeK1"?"yes":""}
                   className="input-textbox"  value="CornerTypeK1"  name={objectName+"CornerType1"} 
                   onChange={e=>{setCornerType("CornerTypeK1");
                    setItemValue({value:50,resolution:"%"});
                  
                   
                    callbackItemValue({title:displayName,topLeft:{value:20,resolution:"%"},
                      topRight:{value:10,resolution:"%"},
                      bottomLeft:{value:30,resolution:"%"},
                      bottomRight:{value:50,resolution:"%"}},`${objectName}All`);
                    
                  }}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                         
                        </div> 
                                <div  style={{display:"flex",justifyContent:"space-around"}}> <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                <div style={{display:"flex",justifyContent:"space-between", borderTopLeftRadius:`50%`,
              borderTopRightRadius:`50%`,
              borderBottomLeftRadius:`10%`,
              borderBottomRightRadius:`30%`,width:"30px",height:"30px",background:"rgba(144, 202, 249,0.9)",
              }} > </div> 
                              <input type="radio" title="Set As Years"   checked={cornerType=="CornerTypeK2"?"yes":""}
                   className="input-textbox"  value={"CornerTypeK2"}  name={objectName+"CornerType1"}   
                   onClick={e=>{setCornerType("CornerTypeK2");
                    setItemValue({value:50,resolution:"px"});
                      callbackItemValue({
                       
                        title:displayName,topLeft:{value:50,resolution:"%"},
                      topRight:{value:50,resolution:"%"},
                      bottomLeft:{value:10,resolution:"%"},
                      bottomRight:{value:30,resolution:"%"}},`${objectName}All`);     }}/>
                        <span class={"boxCardBorder-two"} ></span> </label>
                        <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between",
                                             borderTopLeftRadius:`10%`,
              borderTopRightRadius:`30%`,
              borderBottomLeftRadius:`50%`,
              borderBottomRightRadius:`60%`,width:"30px",height:"30px",background:"rgba(144, 202, 249,0.9)",
              }} > </div> 
                              <input type="radio" title="Color Theme"   checked={cornerType=="CornerTypeK3"?"yes":""}
                   className="input-textbox"  value="CornerTypeK3"  name={objectName+"CornerType1"}  
                   onChange={e=>{setCornerType("CornerTypeK3");
                   setItemValue({value:10,resolution:"px"});
                    callbackItemValue({title:displayName,topLeft:{value:10,resolution:"%"},
                      topRight:{value:30,resolution:"%"},
                      bottomLeft:{value:50,resolution:"%"},
                      bottomRight:{value:60,resolution:"%"}},`${objectName}All`);   }}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                              <div style={{display:"flex",justifyContent:"space-between",
                                               borderTopLeftRadius:`20%`,
              borderTopRightRadius:`40%`,
              borderBottomLeftRadius:`10%`,
              borderBottomRightRadius:`80%`,width:"30px",height:"30px",background:"rgba(144, 202, 249,0.9)",
              }} > </div> 
                              <input type="radio" title="Color Theme"   checked={cornerType=="CornerTypeK4"?"yes":""}
                   className="input-textbox"  value="CornerTypeK4"  name={objectName+"CornerType1"} 
                   onChange={e=>{setCornerType("CornerTypeK4");
                    setItemValue({value:50,resolution:"%"});
                   callbackItemValue({title:displayName,topLeft:{value:20,resolution:"%"},
                      topRight:{value:40,resolution:"%"},
                      bottomLeft:{value:10,resolution:"%"},
                      bottomRight:{value:80,resolution:"%"}},`${objectName}All`);
                  }}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                              <div style={{display:"flex",justifyContent:"space-between",
                                               borderTopLeftRadius:`10%`,
              borderTopRightRadius:`30%`,
              borderBottomLeftRadius:`90%`,
              borderBottomRightRadius:`20%`,width:"30px",height:"30px",background:"rgba(144, 202, 249,0.9)",
              }} > </div> 
                              <input type="radio" title="Color Theme"   checked={cornerType=="CornerTypeK5"?"yes":""}
                   className="input-textbox"  value="CornerTypeK5"  name={objectName+"CornerType1"} 
                   onChange={e=>{setCornerType("CornerTypeK5");
                    setItemValue({value:50,resolution:"%"});
                  
                   
                    callbackItemValue({title:displayName,topLeft:{value:10,resolution:"%"},
                      topRight:{value:30,resolution:"%"},
                      bottomLeft:{value:90,resolution:"%"},
                      bottomRight:{value:20,resolution:"%"}},`${objectName}All`);
                    
                  }}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                         
                        </div> </div>
                        
                        
                          </div> 
                        
                         </div></div> 

                                                    </div></div>
                                 </>)

    } 
    export default ItemBorderRadiusUI;

                     

